import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectWorkplaceCount = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('workplace_count')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
